import {
  getPurchaseDetailsError,
  getPurchaseDetailsLoading,
  getPurchaseDetailsSuccess
} from '@Header/Account/ducks/actions';
import HeaderApi from '@services/HeaderApi';

export const fetchPurchaseDetails = url => dispatch => {
  dispatch(getPurchaseDetailsLoading());
  return HeaderApi.fetchHeaderWithAuth(url)
    .then(response => {
      dispatch(getPurchaseDetailsSuccess(response));
    })
    .catch(error => {
      // eslint-disable-next-line
      console.error(error);
      dispatch(getPurchaseDetailsError(error));
    });
};
